import React, { useEffect, useState, useRef } from 'react';
import { getItemToken } from '../../Utils/localStorageUtils';
import MessageBox from './MessageBox';
import { IoClose } from 'react-icons/io5';
import { IconMyClock, } from '../../Assets/MyIcons';
import Defaultloadinggif from '../../layout/Others/Defaultloadinggif';
import { useMyContext } from '../Provider/CommonProvider';

const AdminGalleryModal = ({ modelClose, closeAction, saveAction, changeAction, buttonText, message, sourceType, selectedIds }) => {
    const headers = getItemToken("access_token");
    const BaseUrl = process.env.REACT_APP_Baseurl;
    const listApi = `${BaseUrl}/admin/library/index`;
    const { fetchRequest } = useMyContext()

    const [page, setPage] = useState(1);
    const [type, setType] = useState(sourceType);
    const [limit, setLimit] = useState(null);
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [total, setTotal] = useState('');
    const [hasMore, setHasMore] = useState(true);
    const [image, setImage] = useState()

    // Create a ref for the galleryBox
    const galleryBoxRef = useRef(null);

    const fetchData = async () => {
        if (loading || !hasMore) return;

        const searchParams = {}
        if (type && type !== 5) {
            searchParams.completed = "100"
        }

        try {
            setLoading(true);
            await fetchRequest({
                method: 'GET',
                url: `${listApi}`,
                params: { type, page, limit, title },
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setApiData((prevData) => [...prevData, ...response?.data]);
                        setTotal(response?.pagination);
                        setImage(response?.defaultImage)
                        setHasMore(response?.pagination?.totalPages > page);
                        setLoading(false);
                    }
                }).catch((error => {
                    setLoading(false);
                    console.error(error)
                }))
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    const handleScroll = () => {
        const container = galleryBoxRef.current;
        if (!container) return;
        const scrollHeight = container.scrollHeight;
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        if (Math.round(scrollTop + clientHeight) >= Math.round(scrollHeight - 1)) {
            if (!loading && hasMore) {
                setPage((prevPage) => prevPage + 1);
            }
        }
    };

    useEffect(() => {
        const container = galleryBoxRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    // Reset data when sourceType changes
    useEffect(() => {
        setType(sourceType);
        setPage(1);
        setApiData([]);
        setHasMore(true);
    }, [sourceType]);
    useEffect(() => {
        fetchData();
    }, [page, type]);

    return (
        <div id="galleryModel" className={`modal galleryModal ${modelClose && 'd-block show'} packageModel`}>
            <div className="modal-dialog modal-large" role="document">
                <div className="modal-content theme-bg-color">
                    <div className="modal-header theme-border-bottom-secondary">
                        <MessageBox text="Choose From Library " classname="modal-title theme-text-color admin-modal-title fw-bold" />
                        <div>
                            <button type="button" id="closeModel" className='bg-transparent theme-text-color' onClick={() => closeAction()} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                    </div>
                    <div className="modal-body">
                        {
                            <div className={`d-flex align-items-center flex-wrap galleryBox `} ref={galleryBoxRef}>
                                {apiData?.map((item) => (
                                    <div className='col-4 p-2 position-relative' key={item.id} onClick={() => changeAction(item.id)}>
                                        <input
                                            type="checkbox"
                                            id={`librarySelectItem`}
                                            className='galleryCheckBox'
                                            checked={selectedIds?.includes(item.id)}
                                        />
                                        <div className={`rounded-4 p-3  ${selectedIds?.includes(item.id) ? 'theme-bg-color-secondary' : 'theme-bg-color'} `}>
                                            <img className='rounded-4 galleryImage w-100' src={image} alt={item.title} />
                                            <p className='text-break galleryTitle mt-3 mb-2'>{item.title}</p>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center gap-1'>
                                                    <IconMyClock styled={{ width: "15px", height: "15px" }} />
                                                    <span className='galleryDuration'>{item?.duration}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {loading && (
                                    <div className='col-12 d-flex justify-content-center py-3'>
                                        <Defaultloadinggif />
                                    </div>
                                )}
                                {!hasMore && <p className='col-12 p-2 text-center align-self-center '>No more data !!!</p>}
                            </div>}
                    </div>
                    <div className="modal-footer border-0 d-flex align-items-center gap-3">
                        <button id="closeModel" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => closeAction('clear')}>
                            <MessageBox text="Cancel" />
                        </button>
                        <button type="button" id="libraryProceedButton" className='button-bg-color theme-button-text-color px-4 py-2 rounded-2 md-3' onClick={() => selectedIds?.length ? saveAction(selectedIds) : alert("choose one of the item")} > {buttonText} </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminGalleryModal;
